import naturalCompare from 'string-natural-compare'

export function sortImages (a, b) {
  return naturalCompare(a.name, b.name, {caseInensitive: true})
}